import React from "react";
import {observer} from "mobx-react";
import { ProfileBoxMessagesIndicator } from "../profile-box-messages-indicator.component";
import { IndicatorLayout } from "../consts/indicator-layout";
import {CyClass} from "../../../../common/cy-classes";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";

interface OmgIndicatorProps extends ComponentServicesPick<'omg'> {
    displayLayout?: IndicatorLayout;
}

const ComponentBody: React.FC<OmgIndicatorProps> = observer((props) => {
    const services = useServices();
    
    const onClickHandler = async () => {
        await (await services.menuItemActionFactory).getMenuItemAction('pushNotificationsPermissionsRequest').execute();
        services.analytics.sendOrbitUserFlowEvent("Navigation","NavBar", "Open_OMG");
        // Open OMG
        await props.omg.openOmgAwaitingMessages();
        (await services.userMenu).closeMenu();
        
    }
    
    return (
        <ProfileBoxMessagesIndicator
            displayLayout={props.displayLayout}
            numberOfAwaitingMessages = {props.omg.numberOfAwaitingMessages}
            className = {CyClass('cy-omg-indicator')}
            themeIcon = {services.theme.currentTheme.icons.notificationIcon}
            primaryText = {services.translation.translate('OMG_INDICATOR')}
            onClick={onClickHandler}
        />
    );
})
export const OmgIndicator = withServices(ComponentBody, ['omg']);